import React, { useState, useEffect } from "react";
import axios from "axios";
import { validateHeader, API_Link } from "../commons/Constants";
import { FaTimes, FaRegFileAlt } from "react-icons/fa";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { ProgressBar } from "react-bootstrap";
import { AiOutlineCloudUpload } from "react-icons/ai";

const RisImportComponent = () => {
  const MD5hash = validateHeader();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token;

  useEffect(() => {
    localStorage.setItem("search", "");
    localStorage.setItem("info", "");
    localStorage.setItem("picoData", "");
  }, []);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    const fileName = file.name;

    if (fileName.split(".").pop().toLowerCase() !== "ris") {
      enqueueSnackbar("Please select a .ris file", {
        variant: "error",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
      });
      setSelectedFile(null);
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      const fileContent = e.target.result;

      // Process the content
      const processedContent = fileContent
        .split(/\r?\n/) // Split into lines (handles \n and \r\n line endings)
        .filter((line) => line.trim() !== "") // Remove lines that are empty after trimming
        ?.map((line) => (line.startsWith("TY  -") ? `\n${line}` : line)) // Insert a blank line before lines starting with "TY  -"
        .join("\n"); // Rejoin the lines into a single string

      // Create a new Blob with the processed content
      const processedFile = new Blob([processedContent], { type: file.type });

      // Update the selected file with the processed content
      const processedFileObject = new File([processedFile], fileName, {
        type: file.type,
      });

      setSelectedFile(processedFileObject);
      setShowProgressBar(true);
      setProgress(0);

      // Simulate progress bar for 2 seconds
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            setIsFileUploaded(true); // File is considered uploaded after 2 seconds
            setShowProgressBar(false); // Hide progress bar after upload
          }
          return prev + 25;
        });
      }, 500);
    };

    reader.readAsText(file); // Read the file as text
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    var formData = new FormData();
    formData.append("review_id", localStorage.getItem("studyId") || 1);
    formData.append("file", selectedFile);

    try {
      const config = {
        method: "post",
        url: `${API_Link}importRisFile`,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
          "misr-auth": MD5hash,
        },
        data: formData,
      };

      const response = await axios(config);
      localStorage.setItem("search", JSON.stringify(response.data));
      localStorage.setItem("PICO", 0);

      var data = JSON.stringify({
        Database: "RISimport",
        Population: "",
        Intervention: "",
        Comparison: "",
        Outcomes: "",
        Exclusion: "",
      });

      localStorage.setItem("picoData", data);
      navigate("/listingselections");
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Failed to upload file, try again", {
        variant: "error",

        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelFile = () => {
    setSelectedFile(null);
    setIsFileUploaded(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Optional, stops propagation of the event to parent elements
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Optional, stops propagation of the event

    // Ensure there are files being dropped
    if (e.dataTransfer && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      handleFileSelect({ target: { files: [file] } }); // Call the file select handler
      e.dataTransfer.clearData(); // Optional, clear the drag data after handling
    }
  };
  return (
    <div className="page--content" style={{ backgroundColor: "#F7F7F7" }}>
      <div
        className="container text-center main-page-dev "
        style={{ height: "93%" }}
      >
        <h1 className="ris-file-main-heading">Import RIS File</h1>
        <form
          onSubmit={handleSubmit}
          className="d-flex justify-content-center align-items-center "
          style={{ flexDirection: "column", height: "91%" }}
        >
          <div className=" import-ris-border">
            {!selectedFile && (
              <div
                className="cursor-pointer import-ris-border-secondary d-flex align-items-center justify-content-center "
                onClick={() => document.getElementById("fileUpload").click()}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
              >
                <div className="upload-ris-file-logo">
                  <AiOutlineCloudUpload size={200} />
                  <p>Drag and drop a file or click to select</p>
                </div>
                <input
                  type="file"
                  id="fileUpload"
                  style={{ display: "none" }}
                  onChange={handleFileSelect}
                  accept=".ris"
                />
              </div>
            )}
            {/* Progress Bar using react-bootstrap */}
            {showProgressBar && (
              <div
                className="card mt-4 p-3 position-relative file-uploading-svg"
                style={{
                  width: "100%", // Takes up 100% of the screen's width
                  maxWidth: "120vh", // Ensures it doesn't stretch beyond a certain width
                  margin: "0 auto", // Centers the card horizontally
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  padding: "15px", // Adds padding inside the card
                  position: "relative",
                  boxShadow: "none",
                  backgroundColor: "#f5f5f5",
                }}
              >
                {/* Small cross icon */}
                <FaRegFileAlt size={40} style={{ marginRight: "10px" }} />

                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <p
                    style={{
                      marginBottom: "5px",
                      fontSize: "18px",
                      display: "flex",
                      padding: "0px 5px",
                    }}
                  >
                    {selectedFile.name}
                  </p>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {/* Blue progress bar */}
                    <ProgressBar
                      now={progress}
                      variant="primary"
                      style={{
                        flex: 1,
                        backgroundColor: "#e0e0e0",
                        marginRight: "10px",
                      }}
                    />
                    {/* Percentage text at the end of the progress bar */}
                    <span
                      style={{
                        // fontWeight: "bold",
                        color: "#000", // Text color
                      }}
                    >
                      {progress}%
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* Display Selected File with Cancel Option */}
            {selectedFile && !showProgressBar && (
              <div
                className="card mt-4 p-3 position-relative file-uploading-svg"
                style={{
                  width: "100%", // Takes up 90% of the screen's width
                  maxWidth: "120vh", // Ensures it doesn't stretch beyond a certain width
                  margin: "0 auto", // Centers the card horizontally
                  // borderRadius: "20px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  padding: "15px", // Adds padding inside the card
                  position: "relative",
                  boxShadow: "none",
                  height: "90px",
                  backgroundColor: "#f5f5f5",
                }}
              >
                <FaTimes
                  size={20}
                  style={{
                    position: "absolute",
                    top: "35px",
                    right: "10px",
                    cursor: "pointer",
                    color: "red",
                  }}
                  onClick={handleCancelFile}
                />

                <FaRegFileAlt size={40} style={{ marginRight: "10px" }} />

                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <p
                    style={{
                      marginBottom: "5px",
                      fontSize: "18px",
                      display: "flex",
                      padding: "0px 5px",
                    }}
                  >
                    {selectedFile.name}
                  </p>
                </div>
              </div>
            )}
          </div>
          <div>
            <button
              type="submit"
              className={
                !isFileUploaded || isLoading
                  ? "upload-btn-disable ris-btn upload-btn"
                  : " ris-btn upload-btn"
              }
              disabled={isLoading || !isFileUploaded}
            >
              {isLoading ? "Uploading..." : "Upload File"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RisImportComponent;
